// _utils/dsnGrid.js
// ES Modules 版（必要に応じて関数を足したり削ったりしてください）

const $ = (typeof window !== 'undefined' && (window.jQuery || window.$)) || undefined;

const dsnGrid = {
  getUndefinedVal(v, def) {
    return typeof v === 'undefined' ? def : v;
  },

  backgroundPosition(e, n, t) {
    if (!$) return dsnGrid;
    const $el = e instanceof jQuery ? e : $(e);
    t = this.getUndefinedVal(t, {});
    const o = this.getUndefinedVal(t.sizeX, '105%');
    const i = this.getUndefinedVal(t.sizeY, '105%');
    const s = this.getUndefinedVal(t.left, '-5%');
    const r = this.getUndefinedVal(t.top, '-5%');
    const a = this.getUndefinedVal(t.move, 100);

    $el.css({
      width: o,
      height: i,
      left: s,
      top: r,
      backgroundPositionX: `calc(50% - ${-2 * a}px)`,
      backgroundPositionY: `calc(50% - ${-2 * a}px)`,
    });

    n = this.getUndefinedVal(n, 1);

    $el
      .parent()
      .on('mousemove', function (ev) {
        if (typeof t.dataActive !== 'undefined' && $(this).find($el).hasClass(t.dataActive))
          return false;
        const ix = ev.clientX / $(this).width() - 0.5;
        const iy = ev.clientY / $(this).height() - 0.5;
        if (typeof gsap !== 'undefined') {
          gsap.to($(this).find($el), {
            duration: n,
            transformPerspective: 100,
            x: a * ix + a,
            y: a * iy + a,
          });
        }
        if (typeof t.onEnter !== 'undefined') t.onEnter($(this), ev);
      })
      .on('mouseleave', function (ev) {
        if (typeof gsap !== 'undefined') {
          gsap.to($(this).find($el), { duration: n, x: a, y: a, ease: 'back.out(4)' });
        }
        if (typeof t.onLeave !== 'undefined') t.onLeave($(this), ev);
      });

    return dsnGrid;
  },

  parallaxIt(e, n, t, o) {
    if (!$ || n.length <= 0) return;
    const rect = n[0].getBoundingClientRect();
    const a = e.pageX - rect.left;
    const s = e.pageY - rect.top;
    const r = window.pageYOffset || document.documentElement.scrollTop;
    o = this.getUndefinedVal(o, 0.3);
    t = this.getUndefinedVal(t, -1);

    if (typeof gsap !== 'undefined') {
      gsap.to(n, {
        duration: o,
        x: ((a - rect.width / 2) / rect.width) * t,
        y: ((s - rect.height / 2 - r) / rect.width) * t,
        ease: 'none',
      });
    }
  },

  scaleIt(e, n, t) {
    if (!$ || typeof n === 'undefined') return false;
    const body = $('body');
    let o = 0;
    o = body.hasClass('dsn-effect-scroll') ? e.scrollTop : e.scrollTop();
    let i, a, s;
    s = this.getUndefinedVal(t?.plus, 0);
    i = this.getUndefinedVal(t?.position, false);
    const r = n.offset();
    a = typeof r === 'undefined' || body.hasClass('dsn-effect-scroll') ? 0 : r.top;
    if (i) a -= o;
    return o / (n.height() + a + s);
  },

  scrollerIt(e, n, t) {
    if (!$ || typeof n === 'undefined') return false;
    const s = e.scrollTop();
    const a = this.getUndefinedVal(t?.duration, 0);
    const i = this.getUndefinedVal(t?.plus, 0);
    const r = n.offset();
    let o = typeof r !== 'undefined' ? r.top : 0;
    o += a;
    const d = n.height() + o + i;
    let f;
    if (o <= s && typeof t?.action !== 'undefined') {
      const l = o - s;
      const c = l / d;
      f = s / (n.height() + o + i);
      t.action({ scroll: l, position: c, targetEnd: d, ScrollTop: s, num: f });
    }
    return f;
  },

  setPositionMoveSection(e, n, t) {
    if (!$ || typeof e === 'undefined') return;
    const o = e.offset();
    const i = typeof o === 'undefined' ? 0 : o.top;
    n = dsnGrid.getUndefinedVal(n, 2);
    t = dsnGrid.getUndefinedVal(t, 0);
    const a = (e.innerHeight() + i + t) / 2;
    e.css({ marginBottom: (a / n) * -1 });
  },

  scrollTop(e, n, t, o) {
    if (!$) return;
    n = dsnGrid.getUndefinedVal(n, 500);
    t = dsnGrid.getUndefinedVal(t, 0);
    let i = 0;
    if (typeof e === 'number') {
      i = e;
    } else {
      if (!(e instanceof jQuery)) e = $(e);
      const off = e.offset();
      if (typeof off !== 'undefined') i = off.top;
    }
    $('html, body').animate({ scrollTop: i + t }, n, o);
  },

  mouseMove(e, n, t) {
    if (!$) return;
    const body = $('body');
    if (
      dsnGrid.getUndefinedVal(body.data('dsn-mousemove'), false) &&
      typeof e !== 'undefined' &&
      e &&
      e.length > 0
    ) {
      body.addClass('dsn-mousemove');
      if (!(e instanceof jQuery)) e = $(e);
      const i = e;
      let a = false;
      body.on('mousemove', function (ev) {
        if (typeof gsap !== 'undefined') {
          gsap.to(i, { duration: 0.5, left: ev.pageX, top: ev.pageY });
        }
        if (typeof n?.onUpdate !== 'undefined') n.onUpdate(ev, ev.pageX, ev.pageY, i);
        if (typeof n?.onComplete !== 'undefined') {
          a = true;
          dsnGrid.endAnimate(i, function (ev2) {
            if (a) n.onComplete(ev2, i);
            a = false;
          });
        }
      });
    }
  },

  endAnimate(e, n) {
    if (typeof n !== 'undefined' && n !== null) {
      e.one(
        'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
        function (ev) {
          n(ev);
        }
      );
    }
  },

  mouseWheel(e, n, t) {
    e.bind('mousewheel DOMMouseScroll', function (ev) {
      if (ev.originalEvent.wheelDelta > 0 || ev.originalEvent.detail < 0) {
        if (typeof t !== 'undefined') t(ev);
      } else {
        if (typeof n !== 'undefined') n(ev);
      }
    });
  },

  numberText(e) {
    return e < 10 && e > 0 ? '0' + e : e;
  },

  convertTextLine(e, n) {
    const t = e.html().trim();
    let o = '';
    e.html('');
    for (let i = 0; i < t.length; i++) {
      if (i === 0) o += '<div class="dsn-word-wrapper">';
      if (t.charAt(i) !== ' ') {
        o += `<span class="dsn-chars-wrapper">${t.charAt(i)}</span>`;
      } else {
        o += `</div> ${t.charAt(i)} <div class="dsn-word-wrapper">`;
      }
    }
    o += '</div>';
    n.append(o);
  },

  randomObjectArray(arr, n) {
    const t = this.getUndefinedVal(n, 100);
    return arr.sort(() => Math.round(Math.random()) * t);
  },

  convertTextWord(e, n, t) {
    const words = e.html().trim().split(' ');
    let html = '';
    e.html('');
    for (let a = 0; a < words.length; a++) {
      if (words[a].length > 0) {
        html += '<span class="dsn-wrapper">';
        if (t) {
          html += '<span class="dsn-word-wrapper">';
          for (let s = 0; s < words[a].length; s++) {
            html += `<span class="dsn-chars-wrapper">${words[a].charAt(s)}</span>`;
          }
          html += '</span>';
        } else {
          html += `<span class="dsn-word-wrapper">${words[a]}</span>`;
        }
        html += '</span>';
      }
    }
    n.append(html);
  },

  getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  },

  pageLoad(e, n, t, o) {
    const i = window.performance?.timing;
    const a = (((-1 * ((i?.loadEventEnd ?? 0) - (i?.navigationStart ?? 0))) / 1000) % 50) * 10;
    let s = e;
    const r = n > e ? 1 : -1;
    const d = Math.abs(Math.floor((a + t) / 100));
    const l = setInterval(function () {
      o((s += r));
      if (s >= n) clearInterval(l);
    }, d);
    return l;
  },

  embedVideo(e) {
    if (!$) return;
    $('[data-dsn-video]').each(function () {
      const n = $(this);
      const t = dsnGrid.removeAttr(n, 'data-dsn-video');
      n.on('click', function () {
        n.addClass('dsn-video');
        n.html(`<div class="dsn-iframe-player">${t}</div>`);
        dsnGrid.scrollTop(n, 1600, -100);
      });
    });
  },

  removeAttr(e, n) {
    if (typeof e !== 'undefined' && typeof n !== 'undefined') {
      const t = e.attr(n);
      if (typeof t !== 'undefined') e.removeAttr(n);
      return t;
    }
  },

  moveIcon(e, n) {
    if (!$) return;
    e.on('mousemove', function (t) {
      const o = 'top .15s ease-out,left .15s ease-out';
      n.css({
        '-webkit-transition': o,
        '-moz-transition': o,
        '-ms-transition': o,
        '-o-transition': o,
        transition: o,
        'pointer-events': 'none',
      });
      const i = t.pageX;
      const a = t.pageY - $(this).offset().top;
      if (a > 0 && a < $(this).height() && $(this).offset().left < i && i < e.width()) {
        n.css({ left: i, top: a });
      } else if (typeof gsap !== 'undefined') {
        gsap.to(n, { duration: 0.5, left: '50%', top: '50%' });
      }
    }).on('mouseleave', function () {
      if (typeof gsap !== 'undefined') {
        gsap.to(n, { duration: 0.5, left: '50%', top: '50%' });
      }
    });
  },

  parallaxMoveElemnt(e, n, t, o, i) {
    if (!$) return;
    let a = e,
      s = e;
    if (typeof e.target !== 'undefined') {
      a = e.target;
      s = typeof e.element !== 'undefined' ? e.element : e.target;
    }
    if (s.length <= 0) return;

    t = typeof t === 'undefined' ? 0.5 : parseFloat(t);
    n = typeof n === 'undefined' ? 20 : parseFloat(n);
    i = typeof i !== 'undefined' && i;

    const r = $('<div class="icon-circle"></div>');
    a.append(r);
    a.off('mouseleave')
      .off('mouseenter')
      .off('mousemove')
      .on('mouseleave', function () {
        const to = { x: 0, y: 0, ease: 'back.out(4)' };
        if (i) to.scale = 1;
        const targets = [s, r];
        if (typeof o !== 'undefined') targets.push(o);
        if (typeof gsap !== 'undefined') gsap.to(targets, { duration: 1, ...to });
      })
      .on('mouseenter', function () {
        const base = { transformOrigin: '0 0' };
        if (i && typeof gsap !== 'undefined') {
          gsap.to([s, r], { duration: 0.3, ...base });
        }
      })
      .on('mousemove', (ev) => {
        dsnGrid.parallaxIt(ev, s, n);
        dsnGrid.parallaxIt(ev, r, 2 * n);
        if (typeof o !== 'undefined') dsnGrid.parallaxIt(ev, o, -5, 0.5);
      });
  },

  parallaxMoveElemntCir(e, n, t, o, i) {
    if (!$) return;
    const a = e;
    const self = this;
    t = typeof t === 'undefined' ? 0.5 : parseFloat(t);
    n = typeof n === 'undefined' ? 20 : parseFloat(n);
    i = typeof i !== 'undefined' && i;

    const r = a.html();
    const d = $('<div class="icon-circle"></div>');
    const l = $(`<div class="dsn-grid-parallax">${r}</div>`);
    a.html('').append(d).append(l);

    a.on('mouseleave', function () {
      if (typeof gsap !== 'undefined') {
        gsap.to(a, { duration: t, scale: 1 });
        gsap.to(l, { duration: 0.3, scale: 1, x: 0, y: 0 });
        gsap.to(d, { duration: t, scale: 1, x: 0, y: 0 });
      }
    })
      .on('mouseenter', function () {
        if (typeof gsap !== 'undefined') {
          gsap.to(a, { duration: t, transformOrigin: '0 0', scale: 1 });
          gsap.to(d, { duration: t, scale: 1.2 });
        }
      })
      .on('mousemove', function (ev) {
        self.parallaxIt(ev, l, n);
        dsnGrid.parallaxIt(ev, d, n);
      });
  },

  elementHover(e, n, t) {
    if (!$) return;
    if (!(e instanceof jQuery)) e = $(e);
    if (!(n instanceof jQuery)) n = $(n);
    n.on('mouseenter', function () {
      e.addClass(t);
    }).on('mouseleave', function () {
      e.removeClass(t);
    });
  },

  changeSizeText(e, n) {
    if (!$) return;
    if (!(e instanceof jQuery)) e = $(e);
    e.each(function () {
      const $el = $(this);
      for (const k in n) {
        if ($el.text().length >= parseInt(k, 10)) $el.css(n[k]);
      }
    });
  },

  convertToJQuery(e) {
    if (!$) return e;
    return e instanceof jQuery ? e : $(e);
  },

  animateText(e, n, t, o) {
    if (!$) return;
    const wind = $(window);
    n = this.convertToJQuery(n).each(function () {
      const el = $(this);
      dsnGrid.convertTextWord(el, el);
      if (typeof t !== 'undefined') el.attr(t, 'animate');
      if (typeof o !== 'undefined') el.removeClass(o);
      el.addClass('dsn-has-animate-text');
    });

    const a = 'dsn-animate';
    let s = 0,
      r = null;
    function iFn() {
      n.each(function () {
        const el = $(this);
        if (el.hasClass(a)) return;
        const top = el.offset()?.top;
        if (typeof top !== 'undefined' && s > top - (wind.height() - 100)) {
          if (!el.hasClass(a)) el.addClass(a);
        }
      });
    }
    e.getListener(function (ev) {
      s = typeof ev.offset === 'undefined' ? wind.scrollTop() : 0;
      if (r) clearTimeout(r);
      r = setTimeout(iFn, 10);
    });
  },

  imageLoad() {
    if (!$) return;
    const e = $('[data-dsn-loader="div"]');
    e.each(function () {
      $(this).append(
        '<div class="wait-loader"><div class="loader-inner"><div class="loader-circle"><div class="loader-layer"></div></div></div></div>'
      );
    });
    e.imagesLoaded({ background: '.dsn-img-org' }).progress(function (_ev, n) {
      const t = $(n.element).parents('[data-dsn-loader="div"]');
      if (t.length > 0) {
        t.addClass('dsn-img-loader-done dsn-animate');
        t.attr('data-dsn-loader', 'divFinshed');
      }
    });
  },

  getBoundingClientRect(el) {
    const n = el.getBoundingClientRect();
    return {
      top: n.top,
      right: n.right,
      bottom: n.bottom,
      left: n.left,
      width: n.width,
      height: n.height,
      x: n.x,
      y: n.y,
    };
  },

  progressCircle(e) {
    if (!$) return;
    const n = $('[data-dsn-grid="progress-circle"]');
    const t = this.removeAttr(n, 'data-dsn-grid-stroke');
    const o = typeof t === 'undefined' ? '' : `stroke="${t}"`;

    n.css({
      position: 'fixed',
      right: '-60px',
      bottom: '60px',
      width: '52px',
      height: '52px',
      'z-index': '99999999',
    }).append(
      `<svg class="dsn-progress-circle-up" width="100%" height="100%" ${o} viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet" fill="none">
         <path class="dsn-progress-path" d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
           style="transition: stroke-dashoffset 300ms linear 0s;stroke-dasharray: 307.919, 307.919; stroke-dashoffset: 309;"></path>
       </svg>`
    );

    let i = $(window);
    if (e.isScroller?.(true)) i = e.getScrollbar();

    e.getListener(function (ev) {
      let tScroll = 0;
      let oMax = $(document).height() - $(window).height();
      if (typeof ev.offset === 'undefined') {
        tScroll = $(window).scrollTop();
      } else {
        tScroll = ev.offset.y;
        oMax = $(document).height() - i.getSize().content.height + 100;
      }
      if (tScroll > 70) {
        if (typeof gsap !== 'undefined') {
          gsap.to(n, { duration: 1, ease: 'back.out(4)', right: 60 });
        }
        n.find('.dsn-progress-path').css(
          'stroke-dashoffset',
          300 - Math.round((300 * tScroll) / oMax) + '%'
        );
      } else if (typeof gsap !== 'undefined') {
        gsap.to(n, { duration: 1, ease: 'back.in(4)', right: -60 });
      }
    });

    n.on('click', function () {
      if (e.isScroller?.(true)) {
        i.scrollTo(0, 0, 600);
      } else {
        $('body,html').animate({ scrollTop: 0 }, 300);
      }
    });
  },
};

export default dsnGrid;
